import React from 'react'

export interface CheckboxInterface extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  id: string,
  name: string,
  label?: string,
  error?: boolean,
  wrapperClassName?: string
}

export const Checkbox: React.FC<CheckboxInterface> = ({ 
  id, 
  label, 
  name,
  error, 
  className, 
  wrapperClassName,
  ...rest
}) => {
  return (
    <div className={`form-check ${wrapperClassName}`}>
      <input
        {...rest}
        id={id}
        type="checkbox"
        name={name}
        className={`form-check-input ${className} ${error && 'is-invalid'}`}
      />
      <label className="form-check-label" htmlFor={id}>{label}</label>
    </div>
  )
}

export default Checkbox
